export default [
  {
    path: '/report/leave-summarys',
    name: 'leave-summary-report',
    meta: { requiresAuth: true },
    component: () =>
      import('@/pages/report/leave-summary-report/leave-summary.vue')
  }
]
